import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function ContactPage() {
  return (
    <MinimalPublicPage
      eyebrow="Contact"
      title="Questions, support, or feedback?"
      description="Reach the Ouro team for support, privacy requests, partnerships, or product feedback."
      points={[
        {
          title: "Support",
          body: "Use the support page if you need help with an account, ticket, or match issue.",
        },
        {
          title: "Privacy",
          body: "Privacy requests can be sent to support@ouro.is.",
        },
        {
          title: "Community",
          body: "Join Discord if you want queue updates, regional events, and product discussion.",
        },
      ]}
      secondaryLabel="Support"
      secondaryTo="/support"
    />
  );
}
